import { Controller } from "@hotwired/stimulus"
import { useActionCable } from "shared/web_socket"

export default class extends Controller {
  connect() {
    this.actionCable = useActionCable(this, {
      channel: "Admin::AiTaskChannel"
    })
  }

  disconnect() {
    if (this.actionCable) {
      this.actionCable.unsubscribe()
    }
  }

  onCableReceived(message) {
    if (message.event === "ai_task_completed") {
      const payload = {
        taskType: message.task_type,
        result: message.result
      }

      // Enqueue the event to prevent race conditions
      if (global.state?.aiTaskEvents) {
        global.state.aiTaskEvents.push(payload)
      }

      // Dispatch the event immediately
      const event = new CustomEvent("ai-task:completed", {
        detail: payload,
        bubbles: false
      })
      window.dispatchEvent(event)
    }
  }
}